export default "__VITE_ASSET__y$2L7vpG__"